import { CE_MODAL_CLOSE } from "@js/actions/studio/modals.js";

export const CE_REMOVE_CONTENT_OPEN = "CE_REMOVE_CONTENT_OPEN";
export const ceRemoveContentOpen = (clientContentID, part) => {
  return {
    type: CE_REMOVE_CONTENT_OPEN,
    client_content_id: clientContentID,
    part: part,
  };
};

export const CE_REMOVE_CONTENT_CONFIRM = "CE_REMOVE_CONTENT_CONFIRM";
export const ceRemoveContentConfirm = () => {
  return {
    type: CE_REMOVE_CONTENT_CONFIRM,
  };
};

export const CE_REMOVE_CONTENT_CANCEL = "CE_REMOVE_CONTENT_CANCEL";
export const ceRemoveContentCancel = () => {
  return {
    type: CE_MODAL_CLOSE,
  };
};
